import Login from './views/login';
import Profile from './views/profile';
import Unautorized from './views/unautorized';
import Oauth from './views/oauth';

export default [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {layout: "layoutUser", pageOrder: 0}
  },
  {
    path: '/unautorized',
    name: 'Unautorized',
    component: Unautorized,
    meta: {layout: "layoutUser", pageOrder: 0}
  },
  {
    path: '/oauth',
    name: 'Oauth',
    component: Oauth
  },
];
